import { render, staticRenderFns } from "./CompetitionScope.vue?vue&type=template&id=372be13c&"
import script from "./CompetitionScope.vue?vue&type=script&lang=js&"
export * from "./CompetitionScope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports